module.exports = __webpack_public_path__ + "media/images/ups-single-8206a9fa1c43655907d5f82400a8974f.png";